import script from "./SideNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideNotifications.vue?vue&type=script&setup=true&lang=ts"

import "./SideNotifications.vue?vue&type=style&index=0&id=267f4328&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-267f4328"]])

export default __exports__